// -------------------------- //
// Type safe event definition //
// -------------------------- //

export type TrackingPayload = Record<string, any>;
export type ExternalTrack = (
  eventName: string,
  payload: Record<string, any>,
) => void;

export type TrackingEvent<
  N extends string,
  P extends TrackingPayload | undefined,
> = {
  name: N;
  payload: P;
};

export type TrackingEventBuilder<
  N extends string,
  P extends TrackingPayload | undefined,
> = (payload: P) => TrackingEvent<N, P>;

type TrackingEventPartialDefinition<P extends TrackingPayload | undefined> = <
  N extends string,
>(
  name: N,
) => TrackingEventBuilder<N, P>;

export function defineEvent<
  P extends TrackingPayload | undefined = undefined,
>(): TrackingEventPartialDefinition<P> {
  return <N extends string>(name: N) => {
    return (payload: P) => ({ name, payload });
  };
}

// --------------------- //
// Type safe event usage //
// --------------------- //

export type SendTracking = <
  N extends string,
  P extends TrackingPayload | undefined,
>(
  eventBuilder: TrackingEventBuilder<N, P>,
  payload: NoInfer<P>,
) => void;
